function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CableCar = /*#__PURE__*/function () {
  function CableCar(cableReady) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      mimeType = _ref.mimeType;
    _classCallCheck(this, CableCar);
    this.cableReady = cableReady;
    this.mimeType = mimeType !== null && mimeType !== void 0 ? mimeType : 'text/vnd.cable-ready.json';
    this.boundPerform = this.perform.bind(this);
  }
  _createClass(CableCar, [{
    key: "name",
    get: function get() {
      return 'CableCar';
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var anyHeader = window.mrujs.mimeTypes.any;
      window.mrujs.registerMimeTypes([{
        shortcut: 'any',
        header: "".concat(this.mimeType, ", ").concat(anyHeader)
      }, {
        shortcut: 'cablecar',
        header: this.mimeType
      }]);
    }
  }, {
    key: "connect",
    value: function connect() {
      document.addEventListener('ajax:beforeNavigation', this.boundPerform);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener('ajax:beforeNavigation', this.boundPerform);
    }
  }, {
    key: "perform",
    value: function perform(event) {
      var _this = this;
      var fetchResponse = event.detail.fetchResponse;
      if ((fetchResponse === null || fetchResponse === void 0 ? void 0 : fetchResponse.contentType) == null) return;
      if (!this.isCableReadyResponse(fetchResponse.contentType)) return;
      event.preventDefault();
      fetchResponse.json().then(function (response) {
        _this.cableReady.perform(response);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: "isCableReadyResponse",
    value: function isCableReadyResponse(contentType) {
      return Boolean(contentType.includes(this.mimeType));
    }
  }]);
  return CableCar;
}();
function JsErb() {
  var name = 'JsErb';
  return {
    name: name,
    initialize: initialize$1,
    connect: connect$2,
    disconnect: disconnect$2
  };
}
function initialize$1() {
  var _window$mrujs$mimeTyp = window.mrujs.mimeTypes,
    script = _window$mrujs$mimeTyp.script,
    any = _window$mrujs$mimeTyp.any;
  window.mrujs.registerMimeTypes([{
    shortcut: 'any',
    header: "".concat(script, ", ").concat(any)
  }]);
}
function connect$2() {
  document.addEventListener('ajax:complete', injectScriptIntoHead);
}
function disconnect$2() {
  document.removeEventListener('ajax:complete', injectScriptIntoHead);
}
function injectScriptIntoHead(event) {
  var _a, _b, _c, _d;
  if (!isJavascriptResponse((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse) === null || _b === void 0 ? void 0 : _b.contentType)) return;
  // https://github.com/rails/rails/blob/fa1a4b657c7167a8671a359a55de3f9b37f4330b/actionview/app/assets/javascripts/rails-ujs/utils/ajax.coffee#L13
  var script = document.createElement('script');
  var csp = window.mrujs.cspNonce();
  if (csp != null) script.setAttribute('nonce', csp);
  window.mrujs.enableElement(event);
  (_d = (_c = event.detail) === null || _c === void 0 ? void 0 : _c.fetchResponse) === null || _d === void 0 ? void 0 : _d.text().then(function (html) {
    var _a, _b;
    script.text = html;
    (_b = (_a = document.head.appendChild(script)) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(script);
    var _event$detail = event.detail,
      element = _event$detail.element,
      fetchRequest = _event$detail.fetchRequest,
      fetchResponse = _event$detail.fetchResponse;
    // @ts-expect-error
    window.mrujs.navigationAdapter.navigate(element, fetchRequest, fetchResponse);
    // ^ not sure this is actually needed, but we'll leave it just in case.
  }).catch(function (err) {
    return console.error(err);
  });
}
function isJavascriptResponse(contentType) {
  if (contentType == null) return false;
  return Boolean(contentType.match(/\b(?:java|ecma)script\b/));
}
function MrujsTurbo() {
  return {
    name: 'MrujsTurbo',
    initialize: initialize,
    connect: connect$1,
    disconnect: disconnect$1
  };
}
var mimeType = 'text/vnd.turbo-stream.html';
function initialize() {
  var anyHeader = window.mrujs.mimeTypes.any;
  window.mrujs.registerMimeTypes([{
    shortcut: 'any',
    header: "".concat(mimeType, ", ").concat(anyHeader)
  }, {
    shortcut: 'turbo',
    header: mimeType
  }]);
}
function connect$1() {
  document.addEventListener('ajax:beforeNavigation', handleTurboStream);
}
function disconnect$1() {
  document.removeEventListener('ajax:beforeNavigation', handleTurboStream);
}
function handleTurboStream(event) {
  var fetchResponse = event.detail.fetchResponse;
  if (fetchResponse == null) return;
  if (!isTurboResponse(fetchResponse.contentType)) return;
  event.preventDefault(); // => stop the navigationAdapter from trying to handle it.
  fetchResponse.html().then(function (responseHtml) {
    // @ts-expect-error
    window.Turbo.renderStreamMessage(responseHtml);
  }).catch(function (err) {
    console.error(err);
  });
}
function isTurboResponse(contentType) {
  return Boolean(contentType.includes(mimeType));
}
function Shoelace() {
  return {
    name: 'Shoelace',
    connect: connect,
    disconnect: disconnect
  };
}
function connect() {
  document.addEventListener('sl-submit', shoelaceFormListener);
}
function disconnect() {
  document.removeEventListener('sl-submit', shoelaceFormListener);
}
function shoelaceFormListener(event) {
  var _a, _b, _c;
  var form = event.target;
  var formData = event.detail.formData;
  var action = form.getAttribute('action');
  var method = form.getAttribute('method');
  if (action == null) {
    console.warn("No 'action' attribute on your Shoelace form. Aborting...");
    return;
  }
  if (method == null) method = 'get';
  var mrujs = function mrujs() {
    return window.mrujs;
  };
  (_c = (_b = (_a = mrujs()) === null || _a === void 0 ? void 0 : _a.fetch(action, {
    element: form,
    dispatchEvents: true,
    method: method,
    body: mrujs().urlEncodeFormData(formData)
  })) === null || _b === void 0 ? void 0 : _b.then(function () {})) === null || _c === void 0 ? void 0 : _c.catch(function (err) {
    return console.warn(err);
  });
}
export { CableCar, JsErb, MrujsTurbo, Shoelace };